import { Link } from 'react-router-dom'
import { nextStepFits, whyItFits } from './conversationEngine'
import { appendConversationToRegisterHref } from '../../services/advisorLeadService'

export default function AdvisorRecommendation({ course, answers, reason, nextStep, onTalkToHuman, onStartAgain, conversationId, onStartApplication }) {
  if (!course) return null

  const outcomes = (course.whatYouCanDo || []).slice(0, 3)
  const nextCopy = nextStepFits(nextStep)
  const registerHref = appendConversationToRegisterHref(`/register?course=${course.code}`, conversationId, course.code)

  return (
    <article className="advisor-reply mt-4" aria-labelledby="advisor-recommended-path">
      <p className="cinema-label mb-3" id="advisor-recommended-path">Recommended path</p>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-light text-white leading-tight">
        {course.title}
      </h2>

      <div className="mt-8 space-y-8">
        <div>
          <p className="cinema-label mb-3">Why it fits</p>
          <p className="cinema-body text-cinema-soft/80">{whyItFits(course, answers, reason)}</p>
        </div>

        {nextCopy ? (
          <div>
            <p className="cinema-label mb-3">A useful next step</p>
            <p className="cinema-body text-cinema-soft/80">{nextCopy}</p>
          </div>
        ) : null}

        <div className="grid grid-cols-2 gap-6">
          <div>
            <p className="cinema-label mb-2">Duration</p>
            <p className="font-display text-xl text-white font-light">
              {course.durationSource === 'postgresql' && course.duration
                ? course.duration
                : 'To be confirmed'}
            </p>
          </div>
          <div>
            <p className="cinema-label mb-2">Current fee</p>
            <p className="font-display text-xl text-white font-light">
              {course.feeSource === 'postgresql' && course.fee
                ? course.fee
                : 'To be confirmed'}
            </p>
          </div>
        </div>

        {outcomes.length > 0 && (
          <div>
            <p className="cinema-label mb-3">Key outcomes</p>
            <ul className="space-y-3">
              {outcomes.map((item) => (
                <li key={item} className="cinema-body text-cinema-soft/80 pl-4 border-l border-cinema-gold/40">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex flex-col gap-3 pt-2">
          <Link to="/explore#programs" className="cinema-btn-ghost w-full">
            Explore this course
          </Link>
          <Link
            to={registerHref}
            className="cinema-btn-primary w-full"
            onClick={onStartApplication}
          >
            Start my application
          </Link>
          <button type="button" onClick={onTalkToHuman} className="cinema-btn-ghost w-full">
            Talk to Admissions
          </button>
          <button
            type="button"
            onClick={onStartAgain}
            className="cinema-btn-text justify-center min-h-[48px] w-full"
          >
            Start again
          </button>
        </div>
      </div>
    </article>
  )
}
